const OVERVIEW_UPDATE_STATE = 'fulcrum/containers/NotebookVoltageRegulator/OVERVIEW_UPDATE_STATE'
const OVERVIEW_ADD_MEMORY = 'fulcrum/containers/NotebookVoltageRegulator/OVERVIEW_ADD_MEMORY'
const OVERVIEW_REFRESH_MEMORY = 'fulcrum/containers/NotebookVoltageRegulator/OVERVIEW_REFRESH_MEMORY'
const UPDATE_STATE_ENTIRE_OBJ = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_STATE_ENTIRE_OBJ'
const OPEN_MEMORY_BROWSER_WITH_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/OPEN_MEMORY_BROWSER_WITH_FILTER'

const TOGGLE_POPUP = 'fulcrum/containers/NotebookVoltageRegulator/TOGGLE_POPUP'
const TOGGLE_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_FILTER'
const UPDATE_CONFIG_SELECTION = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_CONFIG_SELECTION'
const UPDATE_CONFIG_SOURCE = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_CONFIG_SOURCE'
const INITIALIZE_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/INITIALIZE_FILTER'
const ADD_CONFIG = 'fulcrum/containers/NotebookVoltageRegulator/ADD_CONFIG'
const EDIT_CONFIG = 'fulcrum/containers/NotebookVoltageRegulator/EDIT_CONFIG'
const IS_EDIT_PART = 'fulcrum/containers/NotebookVoltageRegulator/IS_EDIT_PART'
const IS_ADD_PART = 'fulcrum/containers/NotebookVoltageRegulator/IS_ADD_PART'
const DELETE_PART = 'fulcrum/containers/NotebookVoltageRegulator/DELETE_PART'
const REFRESH_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/REFRESH_FILTER'


const VENDOR_NAME = 'fulcrum/containers/NotebookVoltageRegulator/VENDOR_NAME'
const PART_NUMBER = 'fulcrum/containers/NotebookVoltageRegulator/PART_NUMBER'
const PART_TYPE = 'fulcrum/containers/NotebookVoltageRegulator/PART_TYPE'
const PHASE_COUNT = 'fulcrum/containers/NotebookVoltageRegulator/PHASE_COUNT'
const EFFICIENCY = 'fulcrum/containers/NotebookVoltageRegulator/EFFICIENCY'
const EDP_PEAK = 'fulcrum/containers/NotebookVoltageRegulator/EDP_PEAK'
const EDP_CONTINUOUS = 'fulcrum/containers/NotebookVoltageRegulator/EDP_CONTINUOUS'
const OUTPUT_VOLTAGE = 'fulcrum/containers/NotebookVoltageRegulator/OUTPUT_VOLTAGE'
const UPDATE_CURRENT_CONFIG = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_CURRENT_CONFIG'
const UPDATE_PHASE_COUNT = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_PHASE_COUNT'
const UPDATE_EFFICIENCY = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_EFFICIENCY'
const UPDATE_EDP_PEAK = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_EDP_PEAK'
const UPDATE_EDP_CONTINUOUS = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_EDP_CONTINUOUS'
const UPDATE_OUTPUT_VOLTAGE = 'fulcrum/containers/NotebookVoltageRegulator/UPDATE_OUTPUT_VOLTAGE'

const SELECT_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/SELECT_FILTER'
const DELETE_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/DELETE_FILTER'
const RESET_FILTER = 'fulcrum/containers/NotebookVoltageRegulator/RESET_FILTER'

const RENDER_EXTRA_INPUT = 'NVVDD'

const RUN_RISK_VALIDATION = 'fulcrum/container/Form/NotebookVoltageRegulator/RUN_RISK_VALIDATION'

export {
  RUN_RISK_VALIDATION,
  OVERVIEW_UPDATE_STATE,
  OVERVIEW_ADD_MEMORY,
  OVERVIEW_REFRESH_MEMORY,
  UPDATE_STATE_ENTIRE_OBJ,
  OPEN_MEMORY_BROWSER_WITH_FILTER,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  INITIALIZE_FILTER,
  ADD_CONFIG,
  DELETE_PART,
  REFRESH_FILTER,
  VENDOR_NAME,
  PART_NUMBER,
  PART_TYPE,
  PHASE_COUNT,
  EFFICIENCY,
  EDP_PEAK,
  EDP_CONTINUOUS,
  OUTPUT_VOLTAGE,
  UPDATE_CURRENT_CONFIG,
  UPDATE_PHASE_COUNT,
  UPDATE_EFFICIENCY,
  UPDATE_EDP_PEAK,
  UPDATE_EDP_CONTINUOUS,
  UPDATE_OUTPUT_VOLTAGE,
  SELECT_FILTER,
  DELETE_FILTER,
  RESET_FILTER,
  RENDER_EXTRA_INPUT,
  EDIT_CONFIG,
  IS_EDIT_PART,
  IS_ADD_PART
}
